import { render, staticRenderFns } from "./CookMenu.vue?vue&type=template&id=2f504ea2&scoped=true"
import script from "./CookMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CookMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CookMenu.vue?vue&type=style&index=0&id=2f504ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f504ea2",
  null
  
)

export default component.exports